import {
  Box,
  Typography,
  Backdrop,
  Button,
  CircularProgress,
} from "@mui/material";
import React, { useEffect } from "react";
import * as yup from "yup";
import InputField from "../../components/Custom/Input/InputField";
import Toastify from "../../components/SnackBar/Toastify";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { getLogin } from "../../redux/action/login/index";
import { connect } from "react-redux";
import "./Login.css";
import { storage } from "../../config/storage";
import { useNavigate } from "react-router-dom";

const schema = yup.object().shape({
  email: yup
    .string()
    .required("Please enter your email")
    .email("Please enter valid email"),
  password: yup
    .string()
    .required("Please enter your password.")
    .min(8, "Password is too short - should be 8 chars minimum."),
});

const defaultValues = {
  email: "",
  password: "",
  //   password: "",
  //   remember: true,
};

const Login = ({ getLogin }) => {
  const [open, setOpen] = React.useState(false);
  const [loader, setloader] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { control, formState, handleSubmit, setError } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;

  const onSubmit = async (model) => {
    setloader(true);
    let item = model;
    getLogin(item).then((res) => {
      if (res.data.status) {
        toast.success(res?.data?.message);
        storage.set.authToken(res?.data?.token);
        setTimeout(() => {
          setloader(false);
          navigate("/profile");
        }, 1000);
      } else {
        res?.data?.errors?.map((item) => {
          return toast.error(item);
        });
        // toast.error(res?.data?.errors);
        // storage.set.userId(res?.data?.user_id);
        setTimeout(() => {
          if (res?.data?.is_email_verified === 0) {
            navigate("/");
          }
          setloader(false);
        }, 1000);
      }
    });
  };

  return (
    <>
      <Box sx={style.outBox}>
        <Box sx={style.mainBox}>
          <Box sx={style.leftBox}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <form
              name="LoginForm"
              onSubmit={handleSubmit(onSubmit)}
              style={{
                width: "70%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                alt="logo"
                // className="logoSize"
                style={{ width: "40%" }}
                src={require("../../assets/Gopher-Logo-Retina.png")}
              />
              <Typography
                sx={{
                  fontSize: { xs: "20px", sm: "20px", md: "24px", lg: "26px" },
                  lineHeight: {
                    xs: "29px",
                    sm: "29px",
                    md: "30px",
                    lg: "31px",
                  },
                  fontWeight: "500",
                  color: "#3D2E57",
                  mt: 3,
                  mb: 3,
                }}
              >
                Welcome to Gopher
              </Typography>

              <InputField
                control={control}
                helperText={errors?.email?.message}
                errors={!!errors.email}
                type={"text"}
                placeholder={"Enter your email"}
                formlabel="Email"
                size={{ xs: "20px", md: "22px", lg: "24px" }}
                color={"#333333"}
                name="email"
                required={"*"}
              />

              <Box sx={{ height: "25px" }} />

              <InputField
                control={control}
                helperText={errors?.password?.message}
                errors={!!errors.password}
                variant="filled"
                placeholder={"Enter password"}
                formlabel="Password"
                size={{ xs: "20px", md: "22px", lg: "24px" }}
                color={"#333333"}
                name="password"
                type={"password"}
                required={"*"}
              />

              <Button
                disableRipple
                sx={{
                  width: "100%",
                  "&.MuiButtonBase-root:hover": {
                    bgcolor: "#FF8D2A",
                    border: "1.5px solid #FF8D2A",
                  },
                  bgcolor: "#FF8D2A",
                  color: "#FFFFFF",
                  border: "1.5px solid #FF8D2A",
                  mt: 4,
                  mb: 4,
                  borderRadius: "5px",
                  fontSize: { xs: "16px", md: "18px", lg: "20px" },
                  fontWeight: 400,
                  textTransform: "none",
                }}
                // color="warning"
                variant="outlined"
                type="submit"
              >
                Login
              </Button>
            </form>
            <Toastify />
          </Box>
          <Box sx={{ width: "50%",height:'100vh',objectFit:'cover' }}>
            <img
              alt="logo"
              // style={{ width: "100%",height:'82%' }}
              className="rightBox"
              src={require("../../assets/adminImage.png")}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getLogin: (item) => dispatch(getLogin(item)),
  };
}
export default connect(null, mapDispatchToProps)(Login);

const style = {
  outBox: {
    width: "100%",
    bgcolor: "#F3F0EE",
    // pt: 5,
    // pb: 5,
  },
  mainBox: {
    maxWidth: "1530px",
    width: "100%",
    minHeight: "500px",
    ml: "auto",
    mr: "auto",
    bgcolor: "white",
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { xs: "center", sm: "flex-end" },
  },
  leftBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: { xs: "100%", md: "50%" },
  },
};
